import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { DataField, H2, Section, TealSubSection } from "./common-components";
import { trimesterEnum } from "../../patient/clinical-services/service-steps/pre-assessment/data";
import {
  calculateAge,
  calculateAgeYear,
  formatDateToDD_MMM_YYYY,
} from "../../../helpers/functions";
import { GetAlertConfirmation } from "../../../helpers/constant";

export const PreAssessmentSpecialPopulations = ({formType, preAssessment}) => {
  // const { preAssessment } = useContext(FormContextMA);
  const specialPopulations = {
    pregnancy: {
      checked: preAssessment?.pregnancyIndicator === "Yes",
      trimester: trimesterEnum.options.find(
        (t) => t.value === preAssessment?.pregnancyTrimester
      )?.label,
      expectancyDate: preAssessment?.expectancyDate
        ? formatDateToDD_MMM_YYYY(preAssessment?.expectancyDate)
        : "",
    },
    breastfeeding: {
      checked: preAssessment?.breastFeedingIndicator === "Yes",
      infantDOB: preAssessment?.infantDOB
        ? formatDateToDD_MMM_YYYY(preAssessment?.infantDOB)
        : "",
    },
  };

  return (
    <Section className="space-y-[0.0833333in]" formType = {formType}>
      <H2>Pre-Assessment - Special Populations</H2>
      <div className="grid grid-cols-2">
        <div className="flex flex-col gap-[0.0833333in]">
          <DataField
            label="Pregnancy"
            value={specialPopulations.pregnancy.checked || "Does Not Apply"}
          />
          {specialPopulations.pregnancy.checked ? (
            <>
              <DataField
                label="Trimester"
                value={specialPopulations.pregnancy.trimester}
              />
              <DataField
                label="Expectancy Date"
                value={specialPopulations.pregnancy.expectancyDate}
              />
            </>
          ) : <></>}
        </div>
        <div className="flex flex-col gap-[0.0833333in]">
          <DataField
            label="Breastfeeding"
            value={specialPopulations.breastfeeding.checked || "Does Not Apply"}
          />
          {specialPopulations.breastfeeding.checked ? (
            <DataField
              label="Infant Date of Birth"
              value={specialPopulations.breastfeeding.infantDOB}
            />
          ) : <></>}
        </div>
      </div>
      {preAssessment?.pregnancyAlertConfirmationType && preAssessment?.pregnancyAlertConfirmationType !== 0 ? (
        <TealSubSection className="space-y-[0.0416667in]">
          {/* TODO: data for values? */}
          <DataField
            label="Referral Reason"
            value={"Pregnancy Alert"}
          />
          <DataField
            label="Referral Type"
            value={GetAlertConfirmation(
              preAssessment?.pregnancyAlertConfirmationType
            )}
          />
          {(preAssessment?.pregnancyAlertConfirmationType === 1 ||
            preAssessment?.pregnancyAlertConfirmationType === 2) ? (
            <DataField
              label="Explanation"
              value={preAssessment?.pregnancyAlertExplaination}
            />
          ) : <></>}
          <DataField
            label={`Pharmacist Clinical Decision to ${
              preAssessment?.pregnancyAlertConfirmationType === 4
                ? "End Service"
                : "Continue with Service"
            }`}
            value={""}
          />
        </TealSubSection>
      ) : <></>}
    </Section>
  );
};
